/// <amd-module name="typeahead/core/message/SuggestionSelectedMessage" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Suggestion} from "typeahead/core/Suggestion";

export class SuggestionSelectedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.suggestion_selected";
    }

    private selectionMethod: string;

    constructor(private readonly suggestion: Suggestion,
                private readonly requestId: string,
                e: BaseJQueryEventObject,
                private readonly lob: string,
                private readonly domElementId: string) {
        this.selectionMethod = (e && e.type) ? (e.type.indexOf("mouse") > -1 ? "mouse" :
            e.type.indexOf("key") > -1 ? "keyboard" : e.type.indexOf("touch") > -1 ? "touch" : "unknown") : "unknown";
    }

    public getTopic(): string {
        return SuggestionSelectedMessage.getTopic();
    }

    public getSuggestion(): Suggestion {
        return this.suggestion;
    }

    public getDomElementId(): string {
        return this.domElementId;
    }

    public getSelectionMethod(): string {
        return this.selectionMethod;
    }

    public getLob(): string {
        return this.lob;
    }

    public getRequestId(): string {
        return this.requestId;
    }
}
